{
  "title": "Lightning Bolt",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level evocation",
  "level": 3,
  "castingTime": "1 action",
  "range": "Self (100-foot line)",
  "components": "V, S, M (a bit of fur and a rod of amber, crystal, or glass)",
  "duration": "Instantaneous",
  "description": [
    "A stroke of lightning forming a line of 100 feet long and 5 feet wide blasts out from you in a direction you choose. Each creature in the line must make a Dexterity saving throw. A creature takes 8d6 lightning damage on a failed save, or half as much damage on a successful one.",
    "The lightning ignites flammable objects in the area that aren’t being worn or carried.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, the damage increases by 1d6 for each slot level above 3rd."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
